import React, { useState } from 'react';
import { Spin, Alert } from 'antd';
import { useH301Query } from './hooks/useH301Query';
import QueryParams from './components/QueryParams';
import ResultTable from './components/ResultTable';
import type { QueryRequest } from '../../services/h301Api';

/**
 * Get today's date as YYYY-MM-DD string.
 */
function getTodayStr(): string {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
}

const H301Form: React.FC = () => {
  const { loading, result, queried, noData, runQuery } = useH301Query();

  const [supplierFrom, setSupplierFrom] = useState('');
  const [supplierTo, setSupplierTo] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState(getTodayStr());
  const [deptFrom, setDeptFrom] = useState('');
  const [deptTo, setDeptTo] = useState('');
  const [balanceFilter, setBalanceFilter] = useState(2);
  const [includeUnapproved, setIncludeUnapproved] = useState(false);
  const [reportType, setReportType] = useState('supplier');

  const handleQuery = () => {
    const req: QueryRequest = {
      supplierFrom: supplierFrom.trim(),
      supplierTo: supplierTo.trim(),
      dateFrom: dateFrom.trim(),
      dateTo: dateTo.trim(),
      deptFrom: deptFrom.trim(),
      deptTo: deptTo.trim() || 'zzzz',
      balanceFilter,
      includeUnapproved,
      reportType,
    };
    runQuery(req);
  };

  return (
    <Spin spinning={loading}>
      <div className="h301-container max-w-7xl mx-auto p-4">
        <h2 className="text-xl font-bold mb-4">
          應付未付款項明細 (H3011)
        </h2>

        <QueryParams
          supplierFrom={supplierFrom}
          supplierTo={supplierTo}
          dateFrom={dateFrom}
          dateTo={dateTo}
          deptFrom={deptFrom}
          deptTo={deptTo}
          balanceFilter={balanceFilter}
          includeUnapproved={includeUnapproved}
          reportType={reportType}
          loading={loading}
          onSupplierFromChange={setSupplierFrom}
          onSupplierToChange={setSupplierTo}
          onDateFromChange={setDateFrom}
          onDateToChange={setDateTo}
          onDeptFromChange={setDeptFrom}
          onDeptToChange={setDeptTo}
          onBalanceFilterChange={setBalanceFilter}
          onIncludeUnapprovedChange={setIncludeUnapproved}
          onReportTypeChange={setReportType}
          onQuery={handleQuery}
        />

        {queried && !noData && result && (
          <ResultTable result={result} reportType={reportType} />
        )}

        {queried && noData && (
          <Alert
            message="查無資料"
            description="查無符合條件的應付帳款資料！請確認篩選條件是否正確。"
            type="info"
            showIcon
          />
        )}
      </div>
    </Spin>
  );
};

export default H301Form;
